import React from 'react';
import { Link as ReactDomLink } from 'react-router-dom';
import { Link as ChakraUiLink } from '@chakra-ui/react';

function Link({ to, state, style, children }) {
    return <ChakraUiLink _hover={{}} _focusVisible={{}} {...style} as={ReactDomLink} to={to} state={state}>{children}</ChakraUiLink>
}

export default Link;
